module.exports = __webpack_public_path__ + "fonts/password_70x70.4200375d35ebb674c40a1ebc2b41c22b.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/password_70x70.png
// module id = 774
// module chunks = 9